module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"max":"max","min":"min"},"de":{"max":"max","min":"min"}}')
  delete Component.options._Ctor
}
